import m, {Vnode} from "mithril";
import {LabelItem} from "../../../../model/items/labelItem";
import {Questionary} from "../../../../model/questionary";

export default class LinkCell {

    private readonly questionary: Questionary;

    constructor(
        public readonly label: LabelItem,
        public readonly url: string,
        public readonly onClick?: (e: MouseEvent)=>void,
    ) {
        this.questionary = label.cell.grid.questionary;
    }

    public view(): Vnode|null {

        if (!this.label.cell.visible) {
            return null;
        }

        const cssClass = 'linkCell' + (this.label.cell.cssClass ? (' '+this.label.cell.cssClass) : '');

        return m("div", {
            "class": cssClass,
        }, [
            m(
                "a", {
                    target: '_blank',
                    href: this.url,
                    onclick: (e: MouseEvent) => this.onClick?.(e),
                }, m.trust(this.questionary.renderText(this.label.childrenTags[0]?.value || ''))
            ),
        ]);
    }
}